import { useHttpClient } from '@/common/api/httpClient';
import type { VehicleResponse } from './models/vehicleResponse';
import { useLanguageStore } from 'shared/translations/stores/languageStore';
import { storeToRefs } from 'pinia';
import { useVehicleStore } from 'shared/vehicles/stores/vehicleStore';
import type { VehicleRequest } from './models/vehicleRequest';

export interface UpdateVehicleSuccessResponse {
  ok: true;
  vehicle: VehicleResponse;
}

export function useUpdateVehicle() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);
  const store = useVehicleStore();

  return {
    execute,
  };

  async function execute(vehicle: VehicleRequest) {
    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`vehicle`), {
      method: 'PUT',
      headers,
      body: JSON.stringify(vehicle),
    });

    const text = translations.value.vehicles.actions.update;

    const response = await httpClient.action<UpdateVehicleSuccessResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const json = (await response.json()) as VehicleResponse;
        store.add(json);
        return {
          ok: true,
          vehicle: json,
        };
      },
    });

    return response;
  }
}
